import VueRouter from 'vue-router';

import di from 'di';
import { default as ErrorView, Mode as ErrorMode } from 'js-ui/js/components/views/ErrorView.vue';

import Permission from 'app/enums/Permission';
import Login from 'app/components/routes/Login.vue';
import AppTemplate from 'app/components/AppTemplate.vue';
import Users from 'app/components/routes/user/Users.vue';
import Ships from 'app/components/routes/ships/Ships.vue';
import UserForm from 'app/components/routes/user/UserForm.vue';
import ShipForm from 'app/components/routes/ships/ShipForm.vue';
import Parcels from 'app/components/routes/parcels/Parcels.vue';
import Growers from 'app/components/routes/growers/Growers.vue';
import Sections from 'app/components/routes/sections/Sections.vue';
import ParcelForm from 'app/components/routes/parcels/ParcelForm.vue';
import GrowerForm from 'app/components/routes/growers/GrowerForm.vue';
import SampleForm from 'app/components/routes/actions/SampleForm.vue';
import SowingForm from 'app/components/routes/actions/SowingForm.vue';
import AccountForm from 'app/components/routes/account/AccountForm.vue';
import HarvestForm from 'app/components/routes/actions/HarvestForm.vue';
import SectionForm from 'app/components/routes/sections/SectionForm.vue';
import CohortDetail from 'app/components/routes/overviews/CohortDetail.vue';
import TreatmentForm from 'app/components/routes/actions/TreatmentForm.vue';
import SectionDetail from 'app/components/routes/sections/SectionDetail.vue';
import OverviewPeriod from 'app/components/routes/overviews/OverviewPeriod.vue';
import CurrentCohorts from 'app/components/routes/overviews/CurrentCohorts.vue';
import WaterInsights from 'app/components/routes/waterInsights/WaterInsights.vue';

export default function() {

    const routes = [
        {
            name: 'login',
            path: '/login',
            component: Login,
            meta: {
                authorized: false
            }
        },
        {
            path: '/',
            component: AppTemplate,
            redirect: { name: di.get('config').homeRoute },
            children: [
                {
                    name: 'account',
                    path: 'account',
                    component: AccountForm
                },
                {
                    name: 'users',
                    path: 'users',
                    component: Users,
                    meta: {
                        access: Permission.ROUTE_USERS
                    }
                },
                {
                    name: 'user-add',
                    path: 'users/add',
                    component: UserForm,
                    meta: {
                        access: Permission.ROUTE_USERS
                    }
                },
                {
                    name: 'user-edit',
                    path: 'users/:id',
                    component: UserForm,
                    meta: {
                        access: Permission.ROUTE_USERS
                    }
                },
                {
                    name: 'ships',
                    path: 'ships',
                    component: Ships,
                    meta: {
                        access: Permission.ROUTE_SHIPS
                    }
                },
                {
                    name: 'ship-add',
                    path: 'ships/add',
                    component: ShipForm,
                    meta: {
                        access: Permission.ROUTE_SHIPS
                    }
                },
                {
                    name: 'ship-edit',
                    path: 'ships/:id',
                    component: ShipForm,
                    meta: {
                        access: Permission.ROUTE_SHIPS
                    }
                },
                {
                    name: 'parcels',
                    path: 'parcels',
                    component: Parcels,
                    meta: {
                        access: Permission.ROUTE_PARCELS
                    }
                },
                {
                    name: 'parcel-add',
                    path: 'parcels/add',
                    component: ParcelForm,
                    meta: {
                        access: [Permission.ROUTE_PARCELS, Permission.MUTATE_PARCELS]
                    }
                },
                {
                    name: 'parcel-edit',
                    path: 'parcels/:id',
                    component: ParcelForm,
                    meta: {
                        access: [Permission.ROUTE_PARCELS, Permission.MUTATE_PARCELS]
                    }
                },
                {
                    name: 'growers',
                    path: 'growers',
                    component: Growers,
                    meta: {
                        access: Permission.ROUTE_GROWERS
                    }
                },
                {
                    name: 'grower-add',
                    path: 'growers/add',
                    component: GrowerForm,
                    meta: {
                        access: Permission.ROUTE_GROWERS
                    }
                },
                {
                    name: 'grower-edit',
                    path: 'growers/:id',
                    component: GrowerForm,
                    meta: {
                        access: Permission.ROUTE_GROWERS
                    }
                },
                {
                    name: 'sections',
                    path: 'sections',
                    component: Sections,
                    meta: {
                        access: Permission.ROUTE_SECTIONS
                    }
                },
                {
                    name: 'section-add',
                    path: 'sections/add',
                    component: SectionForm,
                    meta: {
                        access: [Permission.ROUTE_SECTIONS, Permission.MUTATE_SECTIONS]
                    }
                },
                {
                    name: 'section-edit',
                    path: 'sections/edit/:id',
                    component: SectionForm,
                    meta: {
                        access: [Permission.ROUTE_SECTIONS, Permission.MUTATE_SECTIONS]
                    }
                },
                {
                    name: 'section-detail',
                    path: 'sections/detail/:id',
                    component: SectionDetail,
                    meta: {
                        access: Permission.ROUTE_SECTIONS
                    }
                },
                {
                    name: 'overview-period',
                    path: 'overview-period',
                    component: OverviewPeriod,
                    meta: {
                        access: Permission.ROUTE_OVERVIEW_PERIOD
                    }
                },
                {
                    name: 'current-cohorts',
                    path: 'current-cohorts',
                    component: CurrentCohorts,
                    meta: {
                        access: Permission.ROUTE_COHORTS
                    }
                },
                {
                    name: 'current-cohorts-section-detail',
                    path: 'current-cohorts/section/:id',
                    component: SectionDetail,
                    meta: {
                        access: Permission.ROUTE_COHORTS
                    }
                },
                {
                    name: 'cohort-detail',
                    path: 'cohort-detail',
                    component: CohortDetail,
                    meta: {
                        access: Permission.ROUTE_COHORT_DETAIL
                    }
                },
                {
                    name: 'treatment-edit',
                    path: 'sections/actions/treatment/edit/:id',
                    component: TreatmentForm,
                    meta: {
                        access: Permission.ROUTE_ACTIONS_EDIT
                    }
                },
                {
                    name: 'sample-edit',
                    path: 'sections/actions/sample/edit/:id',
                    component: SampleForm,
                    meta: {
                        access: Permission.ROUTE_ACTIONS_EDIT
                    }
                },
                {
                    name: 'harvest-edit',
                    path: 'sections/actions/harvest/edit/:id',
                    component: HarvestForm,
                    meta: {
                        access: Permission.ROUTE_ACTIONS_EDIT
                    }
                },
                {
                    name: 'sowing-edit',
                    path: 'sections/actions/sowing/edit/:id',
                    component: SowingForm,
                    meta: {
                        access: Permission.ROUTE_ACTIONS_EDIT
                    }
                },
                {
                    name: 'water-insights',
                    path: 'water-insights',
                    component: WaterInsights,
                    meta: {
                        access: Permission.ROUTE_WATER_INSIGHTS
                    }
                }
            ]
        },
        {
            name: 'forbidden',
            path: '/forbidden',
            props: { mode: ErrorMode.FORBIDDEN },
            component: ErrorView,
            meta: {
                authorized: false
            }
        },
        {
            name: 'error',
            path: '/error',
            component: ErrorView,
            props: { mode: ErrorMode.NOT_FOUND },
            meta: {
                authorized: false
            }
        },
        {
            path: '*',
            component: ErrorView,
            props: { mode: ErrorMode.NOT_FOUND },
            meta: {
                authorized: false
            }
        }
    ];

    const router = new VueRouter({
        mode: 'history',
        linkActiveClass: 'active',
        base: di.get('config').basePath + '/',
        routes
    });

    // Auth hook
    router.beforeEach((to, from, next) => {

        if(to.meta.authorized === false) {

            next();
            return;
        }

        let auth = di.get('auth');

        if(!auth.loggedIn()) {
            next({ name: 'login' });
        }
        else {
            next();
        }
    });

    // ACL hook
    const acl = di.get('acl');
    router.beforeEach(acl.createRouteHook());

    di.set('router', router);
}
